import React, { Component } from 'react';
import voca from 'voca';
import { CURRENT_USER } from 'drapcode-constant';
import { moveDefaultCollectionFieldsToEndAndSort } from '../../common/utils/api_utils';
import { extractRefField } from '../../common/utils/field-options';
import { FieldTypes } from 'drapcode-constant';
const { reference } = FieldTypes;

export default class CollectionMappingForm extends Component {
  state = {
    mappingCollectionKey: this.props.collectionMappingRow.key,
    mappingCollectionValue: this.props.collectionMappingRow.value,
    // mappingCollectionType: this.props.collectionMappingRow.type,
  };

  onKeyChange = (e) => {
    this.setState({
      ...this.state,
      mappingCollectionKey: voca.trim(e.target.value),
    });

    this.props.collectionMappingRow.key = voca.trim(e.target.value);
    this.props.createNewCollectionMappingRow(this.props.collectionMappingRow);
  };

  onValueChange = (e) => {
    this.setState({
      ...this.state,
      mappingCollectionValue: e.target.value,
    });
    this.props.collectionMappingRow.value = e.target.value;
    this.props.createNewCollectionMappingRow(this.props.collectionMappingRow);
  };

  collectionFiledsSelect = () => {
    const { selectedCollection, projectDetail, collections } = this.props;
    if (selectedCollection) {
      return (
        <select
          name="mappingCollectionValue"
          className="form-control form-control-sm custom-select-sm"
          onChange={this.onValueChange}
          value={this.state.mappingCollectionValue}
        >
          <option value="">-Select One-</option>
          <optgroup label="Fields">
            {selectedCollection.fields.length > 0 &&
              moveDefaultCollectionFieldsToEndAndSort(selectedCollection.fields, true).map(
                (field) => (
                  <option
                    key={field.fieldName}
                    value={JSON.stringify({ name: field.fieldName, type: 'collection-field' })}
                  >
                    {field.fieldTitle.en}
                  </option>
                ),
              )}
          </optgroup>
          <optgroup label="Reference Collection Fields">
            {selectedCollection.fields.length > 0 &&
              extractRefField(selectedCollection.fields, collections).map((field) => (
                <option
                  key={field.fieldName}
                  value={JSON.stringify({ name: field.fieldName, type: 'reference-field' })}
                >
                  {field.fieldTitle}
                </option>
              ))}
          </optgroup>
          <optgroup label="Derived Fields">
            {selectedCollection.utilities.length > 0 &&
              selectedCollection.utilities.map((field) => (
                <option
                  key={field.name}
                  value={JSON.stringify({ name: field.name, type: 'derived-field' })}
                >
                  {field.name}
                </option>
              ))}
          </optgroup>
          <optgroup label="Collection Constant">
            {selectedCollection.constants.length > 0 &&
              selectedCollection.constants.map((field) => (
                <option
                  key={field.name}
                  value={JSON.stringify({ name: field.name, type: 'collection-constant' })}
                >
                  {field.name}
                </option>
              ))}
          </optgroup>
          <optgroup label="Project Constant">
            {projectDetail &&
              projectDetail.constants &&
              projectDetail.constants
                .filter((fieldObj) => fieldObj.name !== CURRENT_USER)
                .map((field) => (
                  <option
                    key={field.name}
                    value={JSON.stringify({ name: field.name, type: 'project-constant' })}
                  >
                    {field.name}
                  </option>
                ))}
          </optgroup>
        </select>
      );
    }
  };

  render() {
    return (
      <div className="row my-2 mx-auto">
        <div className="col-md-6 col-lg-6 col-sm-6">
          <input
            type="text"
            name="mappingCollectionKey"
            value={this.state.mappingCollectionKey}
            className="form-control form-control-sm"
            onChange={this.onKeyChange}
            placeholder="Key"
          />
        </div>
        <div className="col-md-6 col-lg-6 col-sm-6">{this.collectionFiledsSelect()}</div>
      </div>
    );
  }
}
